module.exports = __webpack_public_path__ + "img/摄图网_501297342_banner_小学生放风筝（非企业商用）.f63d4026.png";